export default "__VITE_ASSET__7703565c__"